import script from "./d4yImg.vue?vue&type=script&setup=true&lang=ts"
export * from "./d4yImg.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__